module.exports = __webpack_public_path__ + "static/media/arrow.7bd98a1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow.svg
// module id = 1710
// module chunks = 0